module.exports = __webpack_public_path__ + "img/titleid.b7383da2.png";